module.exports = __webpack_public_path__ + "media/stylesheets/images/logo_very_small-252f831e1644702c75e8dd3456d39a36.jpg";